export default __webpack_public_path__ + "static/media/LOGO_4.793128e0.svg";